<template>
  <div class="main-wrapper" v-if="user">
    <el-form ref="form" :model="form" status-icon label-width="140px">
      <el-form-item label="账号">
        {{ user.userName }}
      </el-form-item>
      <el-form-item label="密码" prop="password" :rules="[{ required: true, message: '请输入密码' }]">
        <el-input v-model="form.password" type="password" name="password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码"
        prop="confirmPassword"
        :rules="[{ required: true, message: '请输入确认密码' }, { validator: validatePass }]"
      >
        <el-input v-model="form.confirmPassword" type="password" name="confirmPassword" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>

    <el-divider></el-divider>
    <div style="height: 10px"></div>

    <el-row>
      <el-col :span="24" align="center">
        <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
import utils from '@/utils';
import api from '@/api/password';
import { defineComponent } from 'vue';
import { IElForm } from '@/types/element';
import { IUser } from '@/types/models';

interface IForm {
  password: string,
  confirmPassword: string,
}

interface IState {
  user: IUser;
  form: IForm;
}

export default defineComponent({
  data() {
    return {
      user: {} as IUser,
      form: {
        password: '',
        confirmPassword: '',
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.user = res.user;
      });
    },

    apiSubmit() {
      api.submit({
        password: this.form.password,
      }, (res) => {
        if (!res.value) return;
        utils.success('密码更改成功！');
      });
    },

    validatePass(rule: string, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
